import '.c0{flex-shrink:0;}.ssr-plugin'
import '.c2{padding:1rem;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.b3{border:none;}.ssr-plugin'
import '.b4{background-color:transparent;}.ssr-plugin'
import '.ek{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.cn{position:sticky;}.ssr-plugin'
import '.el{top:4rem;}.ssr-plugin'
import '.em{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.en{padding-bottom:1rem;}.ssr-plugin'
import '.w{margin-bottom:1rem;}.ssr-plugin'
import '.eo{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a8{position:fixed;}.ssr-plugin'
import '.co{top:0px;}.ssr-plugin'
import '.bw{left:0px;}.ssr-plugin'
import '.bx{right:0px;}.ssr-plugin'
import '.ep{bottom:0px;}.ssr-plugin'
import '.ee{z-index:9999;}.ssr-plugin'
import '.eq{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dk{justify-content:flex-end;}.ssr-plugin'
import '.c6{flex:1;}.ssr-plugin'
import '.af{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c0 c2 z bl b3 b4 ek"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="cn el em ae en w eo a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a8 co bw bx ep ee ae eq a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c2 a dk eo"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c6 af">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
